import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

/**
 * Resend catering payment link for an order
 * @param {string|number} orderId - Order ID (catering_order_id for single, combine_order_id for combined)
 * @param {boolean} isCombineOrder - Whether this is a combined order (default: false)
 * @returns {Promise} API response
 */
export const resendCateringPaymentLink = async (orderId, isCombineOrder = false) => {
  try {
    // Add query parameter based on order type
    const queryParam = isCombineOrder ? '?is_combine_order=yes' : '?is_combine_order=no';
    const response = await apiClient.post(
      `${API_ENDPOINTS.RESEND_CATERING_PAYMENT_LINK}/${orderId}${queryParam}`,
      {}
    );
    return response;
  } catch (error) {
    console.error("Error resending catering payment link:", error);
    throw error;
  }
};
